
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/information/[flatPage]",
      function () {
        return require("private-next-pages/information/[flatPage].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/information/[flatPage]"])
      });
    }
  